import { z } from "zod";
import { color } from "../../validation/color";

export const validationSchema = z.object({
  color,
  name: z.string().nonempty(),
  projectId: z.string().uuid(),
});
